



















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ams-fixed-table'
})
export default class AMSFixedTable extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  items!: any[];
  @Prop({
    default: () => {
      return [];
    }
  })
  headers!: any[];

  innerHeader: any[] = [];
  contentContainerWidth: number = 0;

  /**左边container样式 */
  get listLeftContainerStyle() {
    var totalWidth = 0;
    this.headers.map((v: any) => {
      if (v.fixed == 'left') {
        const width = parseInt(v.width);
        if (!isNaN(width)) {
          totalWidth += width;
        }
      }
    });
    return `width:${totalWidth}px;`;
  }

  /**右边container样式 */
  get listRightContainerStyle() {
    var totalWidth = 0;
    this.innerHeader.map((v: any) => {
      if (v.fixed == 'right') {
        const width = parseInt(v.width);
        if (!isNaN(width)) {
          totalWidth += width;
        }
      }
    });
    return `width:${totalWidth}px;height:100%;`;
  }

  /**中间container样式 */
  get listContentContainerStyle() {
    var totalLeft = 0;
    var totalRight = 0;
    this.innerHeader.map((v: any) => {
      const width = parseInt(v.width);
      switch (v.fixed) {
        case 'left':
          if (!isNaN(width)) {
            totalLeft += width;
          }
          break;
        case 'right':
          if (!isNaN(width)) {
            totalRight += width;
          }
          break;
        default:
          break;
      }
    });

    this.$nextTick(() => {
      this.updateConteneContainerWidth();
    });

    return `margin-left:${totalLeft}px;margin-right:${totalRight}px;`;
  }

  /**中间container样式 */
  get listContentWidthStyle() {
    var totalWidth = 0;
    var count = 0;
    this.innerHeader.map((v: any) => {
      if (!v.fixed) {
        count += 1;
        const width = parseInt(v.width);
        if (!isNaN(width)) {
          totalWidth += width;
        }
      }
    });

    this.innerHeader.map((v: any) => {
      if (!v.fixed) {
        if (totalWidth > this.contentContainerWidth) {
          v.fixWidth = 0;
        } else {
          const width = this.contentContainerWidth / count;
          v.fixWidth = width;
        }
      }
    });
    return `width:${totalWidth > this.contentContainerWidth ? totalWidth : this.contentContainerWidth}px;`;
  }

  @Watch('headers', { immediate: true, deep: true })
  onHeadersChange(value: any, oldValue: any) {
    console.log(22222);
    this.innerHeader = Object.assign([], value);
    this.$nextTick(() => {
      this.updateConteneContainerWidth();
    });
  }

  @Watch('items', { immediate: true, deep: true })
  onItemsChange(value: any, oldValue: any) {
    console.log(11111);
    this.$nextTick(() => {
      this.updateConteneContainerWidth();
    });
  }

  // onSort(item: any, index: number) {
  //   var head = item;
  //   switch (item.sortType) {
  //     case null:
  //     case '':
  //     case undefined:
  //       head.sortType = 'asc';
  //       break;
  //     case 'asc':
  //       head.sortType = 'desc';
  //       break;
  //     case 'desc':
  //       head.sortType = undefined;
  //       break;
  //     default:
  //       break;
  //   }
  //   this.innerHeader.splice(index, 1, head);
  //   item.sortter(item);
  // }

  onSort(item: any, index: number, order: string) {
    var head = item;
    if (order == item.sortType) {
      head.sortType = undefined;
    } else {
      head.sortType = order;
    }

    this.innerHeader.splice(index, 1, head);
    item.sortter(item);
  }

  updateConteneContainerWidth() {
    const div1 = document.getElementById('listContentContainer');
    if (div1) {
      this.contentContainerWidth = div1.offsetWidth;
    }
  }

  mounted() {
    console.log(45234523452);
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          this.updateConteneContainerWidth();
        });
      })();
    };
    this.$nextTick(() => {
      this.updateConteneContainerWidth();
    });
  }
}
